/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Ourcompany_Pointtwo2Inputs */

const ja_company_ourcompany_pointtwo2 = /** @type {(inputs: Company_Ourcompany_Pointtwo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームは、遊び、問題解決、創造性、コミュニティ、そして競争をもたらします。これらは私たち人間にとって非常に重要な要素であり、eスポーツを含むゲームが社会にポジティブな影響を与えると信じています。そして、この事実が広く受け入れられる社会を目指しています。`)
};

const en_company_ourcompany_pointtwo2 = /** @type {(inputs: Company_Ourcompany_Pointtwo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games bring us Play, Problem Solving, Creativity, Community and Competition; all critical elements to our wellbeing and health as humans. We can think of no better way to spend our time and energy than to help people enjoy gaming.`)
};

/**
* | output |
* | --- |
* | "Games bring us Play, Problem Solving, Creativity, Community and Competition; all critical elements to our wellbeing and health as humans. We can think of no ..." |
*
* @param {Company_Ourcompany_Pointtwo2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_ourcompany_pointtwo2 = /** @type {((inputs?: Company_Ourcompany_Pointtwo2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Ourcompany_Pointtwo2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_ourcompany_pointtwo2(inputs)
	return en_company_ourcompany_pointtwo2(inputs)
});
export { company_ourcompany_pointtwo2 as "company_ourCompany_pointTwo" }